import {DEFAULT_DATAS_PAGE, DEFAULT_DATAS_EVENT, DATA_PAGENAME, DEFAULT_USER_DATA, logger} from './constants';
import {TagManagerLegacy} from './tag-manager-legacy';
import {pushData, tagsPushDataCustom, _getDatasSystem, _getDatasTrafficSource } from './page-tracker';
import {isNoPush, isTrackUser, checkAutoTrackPage, hashCode} from './tag-manager-utils';
import {GTMloader} from './loader';
import WebVitalsManager from './web-vitals';
import { pushUserData } from './user-tracker';

function _trackPage(name, datas, callback) {
  let pagedatas = (datas && typeof datas == 'object') ? datas : {};
  const cb = (callback && typeof callback == 'function') ? callback : null;
  // how pagename is define
  // 0- pagename attribute on datas
  // 1- from 'name' parameter
  // 2- from data-pagename body attribute
  // 3- from location pathname
  let pagename = document.location.pathname;
  if (document.body && document.body.getAttribute(DATA_PAGENAME) && document.body.getAttribute(DATA_PAGENAME).length > 0) {
    pagename = document.body.getAttribute(DATA_PAGENAME);
  }
  if (name && typeof name == 'string' && name.length > 0) {
    pagename = name;
  }
  if (pagedatas.pagename && typeof pagedatas.pagename == 'string' && pagedatas.pagename.length > 0) {
    pagename = pagedatas.pagename;
  }
  
  if ('page_data' in pagedatas) {
    const tmp = Object.assign(pagedatas.page_data, DEFAULT_DATAS_PAGE, _getDatasSystem(), _getDatasTrafficSource());
    pagedatas = {'page_data': {...tmp}};
  } else {
    const tmp = Object.assign(DEFAULT_DATAS_PAGE, _getDatasSystem(), _getDatasTrafficSource(), pagedatas, {pagename: pagename});
    pagedatas = {'page_data': {...tmp}};
  }
  /**
   * Check if consumers send user_data entry on the object that they pass to trackPage
   * That Allow consumers when they deactivate API calls specific to the customer lib
   * To be able to push the user data into the data layer via the trackPage function
   */
  let defaultUserData = {'user_data': DEFAULT_USER_DATA};

  if( pagedatas?.page_data?.user_data ) {
    defaultUserData = { 'user_data': pagedatas.page_data.user_data };
    delete(pagedatas.page_data.user_data);
  }

  let datasToPush = Object.assign({}, DEFAULT_DATAS_PAGE, defaultUserData, pagedatas, {pagename: pagename});
  /**
   check track user is disabled 
   by default trackuser is enabled
   if we want to disable it we have to add attribute data-gtmdisabletrackuser=1 to the body tag
   */
  if(!isTrackUser()) {
    return pushUserData().then((userData) => {
      //user_data à ajouter et tester
      const userDataGA4 = { 'user_data': userData };
      pagedatas.page_data.clienttype = userData.clienttype || DEFAULT_DATAS_PAGE.clienttype;
      datasToPush = Object.assign({}, DEFAULT_DATAS_PAGE, userData, userDataGA4, pagedatas, {pagename: pagename});
      return pushData(datasToPush, cb);
    }).catch(() => {
      return pushData(datasToPush, cb);
    })
  }
  return pushData(datasToPush, cb);
}

function _trackEvent(datas, callback) {
  if (datas && typeof(datas) == 'object' && Object.getOwnPropertyNames(datas).length != 0) {
    const cb = (callback && typeof callback == 'function') ? callback : null;
    return tagsPushDataCustom(Object.assign({}, datas), cb);
  } else {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - Datas event must be an object not null and not empty');
    return false;
  }
}

function _trackCheckout(datas, callback) {
  if (datas && typeof(datas) == 'object' && Object.getOwnPropertyNames(datas).length != 0) {
    const cb = (callback && typeof callback == 'function') ? callback : null;
    return tagsPushDataCustom(datas, cb);
  } else {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - Datas event must be an object not null and not empty');
    return false;
  }
}
/*
function formatEventObj(event, element) {
  if (typeof event.eventLabel === 'function') {
    event.eventLabel = event.eventLabel(element);
  }
  if (typeof event.eventAction === 'function') {
    event.eventAction = event.eventAction(element);
  }
  return (event);
}

function addEventToElements(events, selector) {
  const childToBind = events[selector].childToBind;
  const tagEvents = events[selector].tagEvents;
  const htmlElements = (childToBind) ? document.querySelectorAll(selector + ' ' + childToBind) : document.querySelectorAll(selector);
  if (htmlElements && tagEvents) {
    tagEvents.forEach((event) => {
      htmlElements.forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          const eventLink = e.target;
          // Format the event object to get the values as strings when needed
          const formattedEventObject = formatEventObj(event, element);
          TagManager.trackEvent(formattedEventObject, function() {
            window.open(eventLink.href, eventLink.target !== '' ? eventLink.target : '_self');
          });
        });
      });
    });
  }
}

function handleMutationObservers(events, selector) {
  // Format the selector to remove the '.' from the string
  const selectorRoot = selector.split(".").pop();
  // Get all the elements from the parent selector
  const targets = document.getElementsByClassName(selectorRoot);
  // Get the nodes from HTML elements
  for (const targetNode of targets) {
    const config = { attributes: true, childList: true, subtree: true };
    const callback = function(mutationsList) {
      for (const mutation of mutationsList) {
        // Detect a new child added to the DOM
        if (mutation.type === 'childList') {
          const newChild = mutation.target.className;
          for (const selector in events) {
            // Add an event listener if the new child matches an event selector
            if (newChild.includes(selectorRoot) && selector.includes(selectorRoot)) {
              addEventToElements(events, selector);
            }
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}
*/
function _initEventTrackingListener(data) {
  TagManager.registerConfigurationEventTracking(data);
  // const events = data.events;
  // for (const selector in events) {
  //   addEventToElements(events, selector);
  //   handleMutationObservers(events, selector);
  // }
}

function _initDefaultAutoTracking () {
  GTMloader.loadGTM(function() {
    checkAutoTrackPage().then(function(autoTrack) {
      // eslint-disable-next-line no-console
      logger('## TagManager - auto track page', autoTrack);
      autoTrack && TagManager.trackPage();
      // Initializing Core Web Vitals as soon as possible
      // eslint-disable-next-line no-console
      logger('## TagManager - Web vitals init');
      WebVitalsManager.init();
    });
  }, function() {
    // eslint-disable-next-line no-console
    console.error('## TagManager - callback error on load script');
  });
}

const TagManager = {
  getDefaultDatasEvent: () => DEFAULT_DATAS_EVENT,
  getDefaultDatasPage: () => DEFAULT_DATAS_PAGE,
  trackEvent: _trackEvent,
  trackPage: _trackPage,
  trackCheckout: _trackCheckout,
  initEventTrackingListener: _initEventTrackingListener,
  initDefaultAutoTracking: _initDefaultAutoTracking,
  // DEPRECATED METHODS
  registerConfigurationEventTracking: (conf, isNativeJS = false) => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - isManualPush');
    TagManagerLegacy.registerConfigurationEventTracking(conf, isNativeJS);
  },
  isManualPush: () => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - isManualPush');
    return isNoPush();
  },
  getDefaultObj: () => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - use getDefaultDatasPage() instead of');
    return DEFAULT_DATAS_PAGE;
  },
  _setPageName: () => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - define the pagename on body attribute data-pagename or in method trackPage(pagename,data)');
  },
  _pushData: (data) => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - use trackPage(pagename, data) instead of');
    _trackPage('', data);
  },
  _pushVirtualPageView: () => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - remove call to function _pushVirtualPageView');
  },
  pushDataCustom: (data) => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - use trackEvent(data, callback) instead of');
    return _trackEvent(data);
  },
  tagsPushDataCustom: (data, ui) => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - use trackEvent(data, callback) instead of');
    let cb = ui && ui.cb ? ui.cb : ui;
    return _trackEvent(data, cb);
  },
  fillDatasFromFidelityCards: (obj, fidelityCard, fidelityCards) => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - fillDatasFromFidelityCards');
    return TagManagerLegacy.fillDatasFromFidelityCards(obj, fidelityCard, fidelityCards);
  },
  fillDatasFromPeriod: (obj, period) => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - fillDatasFromPeriod');
    return TagManagerLegacy.fillDatasFromPeriod(obj, period);
  },
  fillDatasFromRoomCriteria: (obj, roomsCriteria) => {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - fillDatasFromRoomCriteria');
    return TagManagerLegacy.fillDatasFromRoomCriteria(obj, roomsCriteria);
  },
  removeNull: function() {
    // eslint-disable-next-line no-console
    console.warn('## Tagmanager - deprecated method - removeNull');
  },
  hashCode: async function(email) {
    /**
     * export of the utility function to allow consumers 
     * who do not go through customer api lib to
     * use the same hash code
     */
    return await hashCode(email);
  }
};

export default TagManager;

// export to window - legacy
window.TagManager = TagManager;

